import styled from "styled-components";

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1em;
  box-sizing: border-box;
  flex-shrink: 0;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  padding: 1em;
`;

export const PanelTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.1em;
  margin-bottom: 0.5em;
`;

export const SubTitle = styled.div`
  display: flex;
  font-size: 0.8em;
  opacity: 0.6;
  margin-bottom: 1em;
`;

export const Controls = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 1em;
  margin-bottom: 0.5em;
`;

export const Label = styled.label`
  display: flex;
  font-size: 0.8em;
  margin-bottom: 0.3em;
  opacity: 0.8;
`;

// Sits directly in Controls so flex-end lines it up with the input boxes
// rather than with the label + input block.
export const Button = styled.div`
  display: flex;
  background-color: #202731;
  box-sizing: border-box;
  border-radius: 4px;
  margin-right: 1em;
  margin-bottom: 0.5em;
  padding: 0.6em 1.5em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  opacity: ${(props) => (props.disabled ? "0.4" : "1")};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  :hover {
    background-color: #db0a41;
  }
`;

export const Empty = styled.div`
  display: flex;
  font-size: 0.8em;
  opacity: 0.6;
  margin-top: 1em;
`;
